import * as React from 'react';
import {observer} from "mobx-react-lite";
import {Col, Row} from "react-bootstrap";


const UnavailableFeature = observer(function UnavailableFeature() {
    return <Row>
        <Col>
            <p>This data is only available in the <a target="_blank" rel="noreferrer" href="https://www.threatstop.com/check-ioc-subscription">ThreatSTOP customer portal</a>.</p>
        </Col>
    </Row>
});

export default UnavailableFeature